export default "__VITE_ASSET__BI6AHoqu__"